/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ValidateIntegrationSourceCodeRequest,
} from '../models/index';
import {
    ValidateIntegrationSourceCodeRequestFromJSON,
    ValidateIntegrationSourceCodeRequestToJSON,
} from '../models/index';

export interface GetContributorPolicyRequest {
    sessionId?: string;
}

export interface ListBundles1Request {
    sessionId?: string;
    featureId?: string;
}

export interface ListCapabilitiesRequest {
    namespace?: string;
}

export interface TestSourceCodeRequest {
    validateIntegrationSourceCodeRequest: ValidateIntegrationSourceCodeRequest;
}

export interface ValidateSourceCodeRequest {
    validateIntegrationSourceCodeRequest: ValidateIntegrationSourceCodeRequest;
}

/**
 * IntegrationMarketplaceBuilderApi - interface
 * 
 * @export
 * @interface IntegrationMarketplaceBuilderApiInterface
 */
export interface IntegrationMarketplaceBuilderApiInterface {
    /**
     * Returns allowed GLOBAL vs TENANT catalog scopes and default for the current user/session.
     * @summary Contributor catalog scope policy
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceBuilderApiInterface
     */
    getContributorPolicyRaw(requestParameters: GetContributorPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns allowed GLOBAL vs TENANT catalog scopes and default for the current user/session.
     * Contributor catalog scope policy
     */
    getContributorPolicy(requestParameters: GetContributorPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Resolves published catalog integrations into bundles that satisfy platform feature dependencies (requiresAll / requiresAnyOf / preferredSlugs). Optional tenant context adds installed and complete flags.
     * @summary Suggest integration bundles for platform features
     * @param {string} [sessionId] Session ID for tenant context
     * @param {string} [featureId] Optional feature filter (e.g. notifications.teams_1to1)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceBuilderApiInterface
     */
    listBundles1Raw(requestParameters: ListBundles1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Resolves published catalog integrations into bundles that satisfy platform feature dependencies (requiresAll / requiresAnyOf / preferredSlugs). Optional tenant context adds installed and complete flags.
     * Suggest integration bundles for platform features
     */
    listBundles1(requestParameters: ListBundles1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns discoverable capability identifiers for marketplace builder pickers. Filter by namespace (communication_channel, provides, entity_type, feature).
     * @summary List integration capability registry
     * @param {string} [namespace] Optional namespace filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceBuilderApiInterface
     */
    listCapabilitiesRaw(requestParameters: ListCapabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns discoverable capability identifiers for marketplace builder pickers. Filter by namespace (communication_channel, provides, entity_type, feature).
     * List integration capability registry
     */
    listCapabilities(requestParameters: ListCapabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns feature dependency definitions including preferredSlugs for bundle UI hints.
     * @summary List platform features and integration requirements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceBuilderApiInterface
     */
    listFeatures1Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns feature dependency definitions including preferredSlugs for bundle UI hints.
     * List platform features and integration requirements
     */
    listFeatures1(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Runs security scan plus syntax/structure checks without starting a full execution.
     * @summary Sandbox test integration activity source code
     * @param {ValidateIntegrationSourceCodeRequest} validateIntegrationSourceCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceBuilderApiInterface
     */
    testSourceCodeRaw(requestParameters: TestSourceCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Runs security scan plus syntax/structure checks without starting a full execution.
     * Sandbox test integration activity source code
     */
    testSourceCode(requestParameters: TestSourceCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Runs runtime security validation on Python/TypeScript source before catalog version save.
     * @summary Validate integration activity source code
     * @param {ValidateIntegrationSourceCodeRequest} validateIntegrationSourceCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceBuilderApiInterface
     */
    validateSourceCodeRaw(requestParameters: ValidateSourceCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Runs runtime security validation on Python/TypeScript source before catalog version save.
     * Validate integration activity source code
     */
    validateSourceCode(requestParameters: ValidateSourceCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationMarketplaceBuilderApi extends runtime.BaseAPI implements IntegrationMarketplaceBuilderApiInterface {

    /**
     * Returns allowed GLOBAL vs TENANT catalog scopes and default for the current user/session.
     * Contributor catalog scope policy
     */
    async getContributorPolicyRaw(requestParameters: GetContributorPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/builder/contributor-policy`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns allowed GLOBAL vs TENANT catalog scopes and default for the current user/session.
     * Contributor catalog scope policy
     */
    async getContributorPolicy(requestParameters: GetContributorPolicyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getContributorPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolves published catalog integrations into bundles that satisfy platform feature dependencies (requiresAll / requiresAnyOf / preferredSlugs). Optional tenant context adds installed and complete flags.
     * Suggest integration bundles for platform features
     */
    async listBundles1Raw(requestParameters: ListBundles1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['featureId'] != null) {
            queryParameters['featureId'] = requestParameters['featureId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/bundles`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Resolves published catalog integrations into bundles that satisfy platform feature dependencies (requiresAll / requiresAnyOf / preferredSlugs). Optional tenant context adds installed and complete flags.
     * Suggest integration bundles for platform features
     */
    async listBundles1(requestParameters: ListBundles1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listBundles1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns discoverable capability identifiers for marketplace builder pickers. Filter by namespace (communication_channel, provides, entity_type, feature).
     * List integration capability registry
     */
    async listCapabilitiesRaw(requestParameters: ListCapabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['namespace'] != null) {
            queryParameters['namespace'] = requestParameters['namespace'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/capabilities`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns discoverable capability identifiers for marketplace builder pickers. Filter by namespace (communication_channel, provides, entity_type, feature).
     * List integration capability registry
     */
    async listCapabilities(requestParameters: ListCapabilitiesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listCapabilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns feature dependency definitions including preferredSlugs for bundle UI hints.
     * List platform features and integration requirements
     */
    async listFeatures1Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/features`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns feature dependency definitions including preferredSlugs for bundle UI hints.
     * List platform features and integration requirements
     */
    async listFeatures1(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.listFeatures1Raw(initOverrides);
        return await response.value();
    }

    /**
     * Runs security scan plus syntax/structure checks without starting a full execution.
     * Sandbox test integration activity source code
     */
    async testSourceCodeRaw(requestParameters: TestSourceCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['validateIntegrationSourceCodeRequest'] == null) {
            throw new runtime.RequiredError(
                'validateIntegrationSourceCodeRequest',
                'Required parameter "validateIntegrationSourceCodeRequest" was null or undefined when calling testSourceCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/builder/test-source-code`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateIntegrationSourceCodeRequestToJSON(requestParameters['validateIntegrationSourceCodeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Runs security scan plus syntax/structure checks without starting a full execution.
     * Sandbox test integration activity source code
     */
    async testSourceCode(requestParameters: TestSourceCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.testSourceCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Runs runtime security validation on Python/TypeScript source before catalog version save.
     * Validate integration activity source code
     */
    async validateSourceCodeRaw(requestParameters: ValidateSourceCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['validateIntegrationSourceCodeRequest'] == null) {
            throw new runtime.RequiredError(
                'validateIntegrationSourceCodeRequest',
                'Required parameter "validateIntegrationSourceCodeRequest" was null or undefined when calling validateSourceCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/builder/validate-source-code`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateIntegrationSourceCodeRequestToJSON(requestParameters['validateIntegrationSourceCodeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Runs runtime security validation on Python/TypeScript source before catalog version save.
     * Validate integration activity source code
     */
    async validateSourceCode(requestParameters: ValidateSourceCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.validateSourceCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
